import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';

import * as yup from 'yup';

/** Nomenclature item and group create and update request body common fields */
export interface NomenclatureBaseFormInterface {
  /** Item/group display name */
  name: string;
}

/** Nomenclature item and group create and update request body common fields - DTO schema */
export const NomenclatureBaseFormDto = SerdeDtoClass.create<NomenclatureBaseFormInterface>(CatalogDtosKeysEnum.NOMENCLATURE_BASE_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
});
